import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=2ff24af3&scoped=true&"
import script from "./Forgot.vue?vue&type=script&lang=ts&"
export * from "./Forgot.vue?vue&type=script&lang=ts&"
import style0 from "./Forgot.vue?vue&type=style&index=0&id=2ff24af3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff24af3",
  null
  
)

export default component.exports